import { Button, CircularProgress, makeStyles, Snackbar } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { useState } from 'react'
import ReactHotkeys from 'react-hot-keys'
import { S3Link } from '../../shared/src/data/s3Link';

const useStyles = makeStyles((theme) => ({
    snackbar: {
      padding: theme.spacing(2),
      fontSize: '1.2rem',
    },
  }));

type SaveButtonProps = {
  saveExecutionParams: () => Promise<S3Link | undefined>
}

export default function SaveButton({ saveExecutionParams }: SaveButtonProps) {
    const classes = useStyles();
    const [savedDialog, setSavedDialog] = useState(false)
    const [isSaving, setIsSaving] = useState(false);
    const saveRegionsOfInterest = async () => {
        setIsSaving(true);
        try {
          await saveExecutionParams()
          setSavedDialog(true)
        } catch (error) {
          console.error('Error saving regions of interest:', error)
          setSavedDialog(false)
        } finally {
          setIsSaving(false);
        }
      }

    const handleKeyDown = async (
        shortcut: string,
        event: KeyboardEvent,
        handle: any,
      ) => {
        if (shortcut === 'ctrl+shift+s' || shortcut === 'command+shift+s') {
            saveRegionsOfInterest()
        }
    }
  return (
    <div style={{ position: 'fixed', bottom: '20px', right: '20px' }}>
      <Snackbar
        open={savedDialog}
        autoHideDuration={2000}
        onClose={() => setSavedDialog(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity='success' className={classes.snackbar}>Saved!</Alert>
      </Snackbar>
      <ReactHotkeys
        keyName={'ctrl+shift+s, command+shift+s'}
        onKeyDown={handleKeyDown}
      />
      <Button
        variant='contained'
        color='secondary'
        disabled={isSaving}
        onClick={saveRegionsOfInterest}
      >
        {isSaving ? <CircularProgress size={24} /> : 'Save'}
      </Button>
    </div>
  )
}
